var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.749,
    height: 12.002,
    viewBox: "0 0 15.749 12.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sign-out-alt",
    "data-name": "Icon awesome-sign-out-alt",
    d: "M15.531,8.531l-5.25,5.25A.751.751,0,0,1,9,13.25v-3H4.75A.748.748,0,0,1,4,9.5v-3a.748.748,0,0,1,.75-.75H9v-3a.752.752,0,0,1,1.281-.531l5.25,5.25A.756.756,0,0,1,15.531,8.531ZM6,13.625v-1.25A.376.376,0,0,0,5.625,12H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H5.625A.376.376,0,0,0,6,3.625V2.375A.376.376,0,0,0,5.625,2H3A3,3,0,0,0,0,5v6a3,3,0,0,0,3,3H5.625A.376.376,0,0,0,6,13.625Z",
    transform: "translate(0 -1.999)",
    fill: "#00aec4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.cb3b01704d123f9d1400e8ff3fab1505.svg";
export { ForwardRef as ReactComponent };